import appConfig from '@/app.config.js'

export function answerForm(index = 0) {
    return {
        title: '',
        image: '',
        is_correct: index == 0,
        score: 0,
        data: {
            sorting_choices: [],
            accepted_percentage: 0,
            completely_correct: true
        }
    }
}

export function generateAnswerForm(range) {
    var answers = []

    for (var i = 0; i < range; i++) {
        answers.push(answerForm(i))
    }

    return answers
}

export function defaultQuiz() {
    return {
        _id: '',
        code: '',
        title: '',
        image: '',
        image_original: '',
        image_placeholder: '',
        image_source: '',
        image_coordinates: {},
        video: null,
        description: '',
        custom_message: '',
        username: '',
        email: '',
        is_random_question_order: false,
        background_color: appConfig.defaultBackgroundColor,
        background_image: '',
        background_image_original: '',
        background_image_source: '',
        background_image_coordinates: {},
        background_image_blur: 0,
        background_image_darken: 0,
        background_image_opacity: 100,
        background_video: '',
        background_type: '',
        background_music: {
            id: 0,
            name: '',
            src: '',
            is_playing: '',
            volume: 0,
        },
        type: 'quiz',
        show_result_on_user_device: false,
        questions: [{
            title: '',
            image: '',
            image_original: '',
            image_source: '',
            image_coordinates: '',
            video: null,
            video_time: null,
            video_mute: null,
            video_loop: false,
            video_provider: null,
            answers_count: 1,
            answers_required: null,
            spotify_track: null,
            puzzle_block: 4,
            question_type: 'basic',
            answers: generateAnswerForm(2),
            custom_message: '',
            status: true,
            chart_type: 'bar',
            fullscreen_desktop: false,
            fullscreen_mobile: false,
        }],
        user_id: '',
        approval_status: '',
        tags: [],
        countries: [],
        age: [0, 99],
        difficult: 5,
        limit_player: 5,
        show_number_question: 10,
        show_correct_answer: true,
        playing_counter: 0,
        class_subject: null,
        class_grade: [],
        show_school_list: false,
        show_school_country_list: false,
        school_id: null,
        status: true,
        themes: defaultThemes(),
        theme_name: 'theme_1',
        share_setting: {
            can_read: false,
            can_edit: false,
            can_access_report: false,
        }
    }
}

export function defaultQuestion() {
    return {
        title: '',
        image: '',
        answers_count: 1,
        answers_required: null,
        spotify_track: null,
        question_type: 'basic',
        video_loop: false,
        fullscreen_desktop: false,
        fullscreen_mobile: false,
        show_full_width_image_mobile: false,
        answers: generateAnswerForm(2),
        custom_message: '',
        status: true,
        chart_type: 'bar',
        is_anywhere: false
    }
}


export function defaultThemes() {

    if (window.defaultThemes && window.defaultThemes().theme_1) {
        return JSON.parse(JSON.stringify(window.defaultThemes()))
    }

    return {
        theme_1: {
            name: 'theme_1',
            question_text_color: '#ffffff',
            question_shadow_color: '',
            button_text_color: '#ffffff',
            ui_color: '#ffffff',
            button_color: '#000000',
            background_image: '',
            background_image_source: '',
            background_image_original: '',
            background_image_coordinates: {},
            background_color: '#cc0000'
        },
        theme_2: {
            name: 'theme_2',
            question_text_color: '#000000',
            question_shadow_color: '',
            button_text_color: '#ffffff',
            ui_color: '#21B6A8',
            button_color: '#18A558',
            background_image: '',
            background_image_source: '',
            background_image_original: '',
            background_image_coordinates: {},
            background_color: '#cc0000'
        },
        theme_3: {
            name: 'theme_3',
            question_text_color: '#000000',
            question_shadow_color: '',
            button_text_color: '#ffffff',
            ui_color: '#B8860B',
            button_color: '#FF8C00',
            background_image: '',
            background_image_source: '',
            background_image_original: '',
            background_image_coordinates: {},
            background_color: '#cc0000'
        }
    }
}
